import { css } from "styled-components"
import { colors } from "../../helpers/colors"
import { BreakPoints, media } from "../../helpers/rwd"

export const SectionWrapperStyles = css`
  background: ${colors.purple};
  ${media.max(BreakPoints.desktop)} {
    padding: 40px 0px 60px;
  }
`;
export const ContentWrapperStyles = css``;
